import type { Directive } from "vue";

const elementMap: Record<string, HTMLElement> = {};

const AutoResizeTextarea: Directive<HTMLTextAreaElement> = {
  mounted(el) {
    el.style["grid-area"] = "1 / 1";
    el.style.height = "auto";
    const parent = el.parentNode as HTMLElement;

    el.oninput = () => {
      if (el.value === "") {
        parent.dataset.value = el.placeholder;
      } else {
        parent.dataset.value = el.value;
      }
    };

    el.onfocus = () => {
      if (el.value === "") {
        parent.dataset.value = el.placeholder;
      } else {
        parent.dataset.value = el.value;
      }
    };

    el.onblur = () => {
      if (el.value === "") {
        parent.dataset.value = el.placeholder;
      } else {
        parent.dataset.value = el.value;
      }
    };

    parent.style.display = "inline-grid";
    parent.style["align-items"] = "stretch";

    const randomClass = "resizer" + Math.ceil(Math.random() * 1000);
    const cssTemplateString = `.${randomClass}::after {content: attr(data-value) " "; visibility: hidden; white-space: pre-wrap; grid-area: 1 / 1; padding: 0.0625rem; padding-top: 0.7rem; font-size: 1rem; line-height: 1.5; word-break: break-word;}`;
    const styleTag = document.createElement("style");
    styleTag.innerHTML = cssTemplateString;
    const element = document.head.insertAdjacentElement("beforeend", styleTag) as HTMLElement;
    parent.classList.add(randomClass);

    parent.dataset.value = el.value;
    elementMap[el.id] = element;
  },

  updated(el) {
    const parent = el.parentNode as HTMLElement;
    parent.dataset.value = el.value;
  },

  unmounted(el) {
    if (elementMap[el.id]) {
      document.head.removeChild(elementMap[el.id]);
      delete elementMap[el.id];
    }
  }
};

export default AutoResizeTextarea;
